import { useTranslation } from 'react-i18next';

import i18n from '../../../../app/i18n';
import { useGetTiles } from '../data.jsx';
import useSort from '../../../../shared/Sort/useSort';

import {
  Table,
  Tr,
  ShadedTr,
  ThContentWrapper,
} from '../../../../shared/TableComponents/StyledComponents';
import {
  StyledCard,
  TableSection,
  Td,
  TdRight,
  ColumnTitle,
  ThContentRight,
  StyledTh,
  TileTd,
  TileImage,
  Placeholder,
  HeadlineLink,
} from './StyledComponents';
import { imgOnError } from '../../../../shared/helpers';
import { QA_TABS } from '../utils/constants';
import Text from '../../../../shared/Text';
import Sort from '../../../../shared/Sort';
import Tooltip from '../../../../shared/Tooltip';

const thSortColumns = [
  { name: 'headline', title: i18n.t('reports:qaTiles.tile') },
  { name: 'assignee', title: i18n.t('reports:qaTiles.assignedTo') },
];

const ThSort = ({ sortingStatus, changeSort }) =>
  thSortColumns.map(column => (
    <StyledTh key={column.name} columnName={column.name}>
      <ThContentWrapper
        columnName={column.name}
        onClick={() => changeSort(column.name)}
      >
        <Sort sortingStatus={sortingStatus} columnName={column.name} />
        <ColumnTitle>{column.title}</ColumnTitle>
      </ThContentWrapper>
    </StyledTh>
  ));

const thStatusColumns = [
  { title: i18n.t('reports:qaTiles.new'), color: '#FF4747' },
  { title: i18n.t('reports:qaTiles.contacted'), color: '#F6A609' },
  { title: i18n.t('reports:qaTiles.answered'), color: '#2AC769' },
];

const ThStatus = () =>
  thStatusColumns.map(column => (
    <StyledTh key={column.title}>
      <ThContentRight>
        <i
          className="fa-solid fa-circle fa-2xs"
          style={{ color: column.color }}
        />
        <ColumnTitle>{column.title}</ColumnTitle>
      </ThContentRight>
    </StyledTh>
  ));

const TilesTable = ({ dataType, tableTitle, campaignId, onTileClick }) => {
  const { sortingStatus, changeSort } = useSort();
  const { t } = useTranslation('reports');
  const { data } = useGetTiles({
    ...sortingStatus,
    campaignId,
    type: dataType,
  });

  const handleOnClick = (row, tab) => {
    if (onTileClick) {
      onTileClick(row.uuid, tab);
    }
  };

  return (
    <>
      <Tooltip />
      <StyledCard
        title={tableTitle}
        titleTooltip={
          dataType === 'live'
            ? t('qaTiles.liveTilesTooltip')
            : t('qaTiles.archivedTilesTooltip')
        }
      >
        {data.length ? (
          <TableSection>
            <Table>
              <colgroup>
                <col span="1" style={{ width: '30%' }}></col>
                <col span="1" style={{ width: '15%' }}></col>
                <col span="1" style={{ width: '10%' }}></col>
                <col span="1" style={{ width: '15%' }}></col>
                <col span="1" style={{ width: '15%' }}></col>
                <col span="1" style={{ width: '15%' }}></col>
              </colgroup>
              <thead>
                <Tr>
                  <ThSort
                    sortingStatus={sortingStatus}
                    changeSort={changeSort}
                  />
                  <ThStatus />
                  <StyledTh>
                    <ThContentRight>
                      <ColumnTitle>{t('qaTiles.allQuestions')}</ColumnTitle>
                    </ThContentRight>
                  </StyledTh>
                </Tr>
              </thead>
              <tbody>
                {data.map(row => {
                  return (
                    <ShadedTr key={row.uuid}>
                      <TileTd
                        onClick={() => handleOnClick(row, QA_TABS.allQuestions)}
                      >
                        <TileImage src={row.tileImage} onError={imgOnError} />
                        <HeadlineLink>{row.tileHeadline}</HeadlineLink>
                      </TileTd>
                      <Td>{row.assignee}</Td>
                      <TdRight>
                        <Text
                          onClick={() => handleOnClick(row, QA_TABS.new)}
                          variant="small2"
                          as="a"
                          color="primary.100"
                        >
                          {row.newQuestions}
                        </Text>
                      </TdRight>
                      <TdRight>
                        <Text
                          onClick={() => handleOnClick(row, QA_TABS.contacted)}
                          variant="small2"
                          as="a"
                          color="primary.100"
                        >
                          {row.contactedQuestions}
                        </Text>
                      </TdRight>
                      <TdRight>
                        <Text
                          onClick={() => handleOnClick(row, QA_TABS.answered)}
                          variant="small2"
                          as="a"
                          color="primary.100"
                        >
                          {row.answeredQuestions}
                        </Text>
                      </TdRight>
                      <TdRight>
                        <Text
                          onClick={() =>
                            handleOnClick(row, QA_TABS.allQuestions)
                          }
                          variant="small2"
                          as="a"
                          color="primary.100"
                        >
                          {row.allQuestions}
                        </Text>
                      </TdRight>
                    </ShadedTr>
                  );
                })}
              </tbody>
            </Table>
          </TableSection>
        ) : (
          <Placeholder>
            {dataType === 'live'
              ? t('qaTiles.livePlaceholder')
              : t('qaTiles.archivedPlaceholder')}
          </Placeholder>
        )}
      </StyledCard>
    </>
  );
};

export default TilesTable;
